"use client";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function HomePage() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate(`${baseUrl}/polizas`);
    } else {
      navigate(`${baseUrl}/login`);
    }
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-[var(--color-z-blue)]" />
    </div>
  );
}
